import React from "react";
import ReactDOM from "react-dom/client";
import "./stylesheets/main.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./redux/store";
import Api from "./services/api";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://894b7e31f3f72ed82bb33836288f7d01@o113767.ingest.us.sentry.io/4509208014880768"
});
Api.init(store, '');

const root = ReactDOM.createRoot(document.getElementById("o-root"));
root.render(
  <React.StrictMode>
    <Provider store={store}> 
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
